import React, { FC } from "react";
import { DsmGrid } from "@dsm-dcs/design-system-react";
import { processAndStageStylesV2 } from "../../../../../../_metronic/layout";
import { CSSClassesList } from "../../../../helpers/helperTypes";
import DsmDialog from "../DsmDialog";
import { useIntl } from "../../../../../../_metronic/i18n/customUseIntl";

type ReportingTypeDescriptionDialog = {
  open: boolean;
  handleClose: () => void;
};

const ReportingTypeDescriptionDialog: FC<ReportingTypeDescriptionDialog> = ({
  open = false,
  handleClose,
}) => {
  const intl = useIntl();
  const classes = processAndStageStylesV2() as CSSClassesList;
  const formTitle = intl.formatMessage({
    id: "BASELINE.REPORTING_TYPE.DESCRIPTIONS.TITLE",
  });
  const formRefs = intl.formatMessage({
    id: "BASELINE.REPORTING_TYPE.DESCRIPTIONS.DESCRIPTION",
  });
  const prefix = "BASELINE.REPORTING_TYPE.DESCRIPTIONS";

  type Items = {
    [key: string]: string;
  };

  const items: Items = {
    FULL_LCA:
      "https://publications.jrc.ec.europa.eu/repository/handle/JRC130796",
    FLAG: "https://ghgprotocol.org/land-sector-and-removals-guidance",
  };

  return (
    <DsmDialog
      openDialog={open}
      title={formTitle}
      description={formRefs}
      icon={{ name: "general/info-circle", variant: "completed" }}
      variant="wide"
      handleClose={handleClose}
    >
      <DsmGrid
        className={
          classes.dsmGridthreeColumn_2_3_NoRowSpacingWithNeutralBordersTitle
        }
        style={{ marginTop: "var(--dsm-spacing-px-6)" }}
      >
        <div>
          <h6 style={{ fontSize: "12px", fontWeight: 500 }}>
            {intl.formatMessage({
              id: "BASELINE.FORM.FIELD.FLAG_REPORTING_TYPE",
            })}
          </h6>
        </div>
        <div
          className={
            classes.dsmGridthreeColumn_2_3_NoRowSpacingWithLinesDescription
          }
        >
          <h6 style={{ fontSize: "12px", fontWeight: 500 }}>
            {intl.formatMessage({ id: "GENERAL.DESCRIPTION" })}
          </h6>
        </div>
        <div
          className={
            classes.dsmGridthreeColumn_2_3_NoRowSpacingWithLinesReference
          }
        >
          <h6 style={{ fontSize: "12px", fontWeight: 500 }}>
            {intl.formatMessage({ id: "GENERAL.REFERENCE" })}
          </h6>
        </div>
      </DsmGrid>
      <DsmGrid
        className={
          classes.dsmGridthreeColumn_2_3_NoRowSpacingWithNeutralBordersBody
        }
      >
        {Object.keys(items).map((key) => (
          <React.Fragment key={key}>
            <div>
              <strong style={{ fontSize: "12px", fontWeight: 500 }}>
                {intl.formatMessage(
                  { id: `${prefix}.${key}.TITLE` },
                  { br: <br /> },
                )}
              </strong>
            </div>
            <div
              className={
                classes.dsmGridthreeColumn_2_3_NoRowSpacingWithLinesDescription
              }
              style={{ fontSize: "14px" }}
            >
              {intl.formatMessage(
                { id: `${prefix}.${key}.DESCRIPTION` },
                { br: <br /> },
              )}
            </div>
            <div
              className={
                classes.dsmGridthreeColumn_2_3_NoRowSpacingWithLinesReference
              }
              style={{ fontSize: "14px" }}
            >
              <a className={classes.referenceLink} href={items[key]}>
                {intl.formatMessage(
                  { id: `${prefix}.${key}.LINK` },
                  { br: <br /> },
                )}
              </a>
            </div>
          </React.Fragment>
        ))}
      </DsmGrid>
    </DsmDialog>
  );
};

export default ReportingTypeDescriptionDialog;
